import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {omit} from 'ramda';

import {LoadPanel as DXLoadPanel} from 'devextreme-react/load-panel';


export default class LoadPanel extends Component {
    constructor(props) {
        super(props);

        this.state = {
            visible: this.props.visible,
        };

        this.onShowing = this.onShowing.bind(this);
        this.onHiding = this.onHiding.bind(this);
    }

    UNSAFE_componentWillReceiveProps(props) {
        this.setState({
            visible: props.visible,
        });
    }

    // static getDerivedStateFromProps(nextProps, prevState){
    //     if (nextProps.visible !== prevState.visible) {
    //         return {
    //             visible: nextProps.visible,
    //         };
    //     }
    //     return null;
    // }

    onShowing(e) {
        this.setState({visible: true});
    }

    onHiding(e) {
        this.setState({visible: false});
    }

    render() {
        const dataAttributes = {};
        if (this.props.loading_state && this.props.loading_state.is_loading) {
            dataAttributes['data-dash-is-loading'] = true;
        }
        return (
            <DXLoadPanel
                {...omit(['loading_state', 'setProps'], this.props)}
                {...dataAttributes}
                onShowing={this.props.onShowing || this.onShowing}
                onHiding={this.props.onHiding || this.onHiding}
                visible={this.state.visible}
            />
        )
    }
}

LoadPanel.propTypes = {
    /**
     * The ID used to identify this component in Dash callbacks
     */
    id: PropTypes.string,

    /**
     * Configures UI component visibility animations. This object contains two fields: show and hide.
     */
    animation: PropTypes.object,
    /**
     * Specifies whether to close the UI component if a user clicks outside it
     */
    closeOnOutsideClick: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    /**
     * Specifies the UI component's container
     */
    container: PropTypes.string,
    /**
     * Specifies whether to render the UI component's content when it is displayed. If false, the content is rendered immediately
     */
    deferRendering: PropTypes.bool,
    /**
     * The delay in milliseconds after which the load panel is displayed
     */
    delay: PropTypes.number,
    /**
     * Specifies the global attributes to be attached to the UI component's container element
     */
    elementAttr: PropTypes.object,
    /**
     * Specifies whether or not the UI component can be focused
     */
    focusStateEnabled: PropTypes.bool,
    /**
     * Specifies the UI component's height in pixels
     */
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),
    /**
     * Specifies text for a hint that appears when a user pauses on the UI component
     */
    hint: PropTypes.string,
    /**
     * Specifies whether the UI component changes its state when a user pauses on it
     */
    hoverStateEnabled: PropTypes.bool,
    /**
     * A URL pointing to an image to be used as a load indicator
     */
    indicatorSrc: PropTypes.string,
    /**
     * Specifies the maximum height the UI component can reach while resizing
     */
    maxHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),
    /**
     * Specifies the maximum width the UI component can reach while resizing
     */
    maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),
    /**
     * Specifies the text displayed in the load panel. Ignored in the Material Design theme
     */
    message: PropTypes.string,
    /**
     * Specifies the minimum height the UI component can reach while resizing
     */
    minHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),
    /**
     * Specifies the minimum width the UI component can reach while resizing
     */
    minWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),
    /**
     * A function that is executed when the UI component's content is ready and each time the content is changed
     */
    onContentReady: PropTypes.func,
    /**
     * A function that is executed before the UI component is disposed of
     */
    onDisposing: PropTypes.func,
    /**
     * A function that is executed after the UI component is hidden
     */
    onHidden: PropTypes.func,
    /**
     * A function that is executed before the UI component is hidden
     */
    onHiding: PropTypes.func,
    /**
     * A function used in JavaScript frameworks to save the UI component instance
     */
    onInitialized: PropTypes.func,
    /**
     * A function that is executed after a UI component property is changed
     */
    onOptionChanged: PropTypes.func,
    /**
     * A function that is executed before the UI component is displayed
     */
    onShowing: PropTypes.func,
    /**
     * A function that is executed after the UI component is displayed
     */
    onShown: PropTypes.func,
    /**
     * Positions the UI component
     */
    position: PropTypes.oneOfType([PropTypes.oneOf(['bottom', 'center', 'left', 'left bottom', 'left top', 'right', 'right bottom', 'right top', 'top']), PropTypes.object]),
    /**
     * Switches the UI component to a right-to-left representation
     */
    rtlEnabled: PropTypes.bool,
    /**
     * Specifies whether to shade the background when the UI component is active
     */
    shading: PropTypes.bool,
    /**
     * Specifies the shading color. Applies only if shading is enabled.
     */
    shadingColor: PropTypes.string,
    /**
     * A Boolean value specifying whether or not to show a load indicator
     */
    showIndicator: PropTypes.bool,
    /**
     * A Boolean value specifying whether or not to show the pane behind the load indicator
     */
    showPane: PropTypes.bool,
    /**
     * A Boolean value specifying whether or not the UI component is visible
     */
    visible: PropTypes.bool,
    /**
     * Specifies the UI component's width in pixels
     */
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),

    /**
     * Object that holds the loading state object coming from dash-renderer
     */
    loading_state: PropTypes.shape({
        /**
         * Determines if the component is loading or not
         */
        is_loading: PropTypes.bool,
        /**
         * Holds which property is loading
         */
        prop_name: PropTypes.string,
        /**
         * Holds the name of the component that is loading
         */
        component_name: PropTypes.string,
    }),
    /**
     * Dash-assigned callback that gets fired when the value changes.
     */
    setProps: PropTypes.func
};

LoadPanel.defaultProps = {
    animation: {show: {type: 'fade', from: 0, to: 1}, hide: {type: 'fade', to: 0}},
    closeOnOutsideClick: true,
    // container: undefined,
    deferRendering: true,
    delay: 0,
    elementAttr: {},
    focusStateEnabled: false,
    height: 90,
    // hint: undefined,
    hoverStateEnabled: false,
    indicatorSrc: '',
    maxHeight: null,
    maxWidth: null,
    message: 'Loading...',
    minHeight: null,
    minWidth: null,
    onContentReady: null,
    onDisposing: null,
    onHidden: null,
    onHiding: null,
    onInitialized: null,
    onOptionChanged: null,
    onShowing: null,
    onShown: null,
    position: {my: 'center', at: 'center', of: window},
    rtlEnabled: false,
    shading: true,
    shadingColor: 'transparent',
    showIndicator: true,
    showPane: true,
    visible: false,
    width: 222
};
